import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Trophy, MessageSquareQuote } from "lucide-react";

const ANSWER_CLS = { loved: "text-amber-300", nice: "text-emerald-300", not_for_me: "text-pink-300", didnt_meet: "text-white/50" };

export const CheckinsPanel = () => {
  const { data } = useQuery({ queryKey: ["admin-checkins"], queryFn: async () => (await api.get("/admin/checkins")).data });
  if (!data) return <p className="text-sm text-white/50">Loading…</p>;
  return (
    <div className="space-y-6">
      <section data-testid="checkin-ranking" className="glass rounded-2xl p-5">
        <p className="font-display font-bold flex items-center gap-2 mb-3"><Trophy className="h-4 w-4 text-amber-400" /> Best events for dates</p>
        {data.ranking.length === 0 ? <p data-testid="checkin-ranking-empty" className="text-sm text-white/50">No check-ins yet — they arrive at noon the day after each event.</p> : (
          <div className="space-y-2">
            {data.ranking.map((e, i) => (
              <div key={e.event_id} data-testid={`ranking-row-${e.event_id}`} className="flex items-center gap-3 text-sm border-b border-white/5 pb-2">
                <span className="w-6 text-amber-300 font-bold">{i + 1}</span>
                <div className="flex-1 min-w-0"><p className="font-semibold truncate">{e.title}</p><p className="text-[11px] text-white/50">{e.venue} · {e.category}</p></div>
                <span className="text-xs text-white/60">{e.checkins} check-ins</span>
                <span className="text-xs text-amber-200">{e.loved_pct}% loved</span>
                <span data-testid={`ranking-score-${e.event_id}`} className="text-sm font-bold text-emerald-300 w-14 text-right">{e.score}/3</span>
              </div>
            ))}
          </div>
        )}
      </section>
      <section data-testid="checkin-list" className="glass rounded-2xl p-5">
        <p className="font-display font-bold flex items-center gap-2 mb-3"><MessageSquareQuote className="h-4 w-4 text-sky-300" /> All check-ins</p>
        {data.checkins.length === 0 ? <p className="text-sm text-white/50">Nothing yet.</p> : (
          <div className="space-y-2">
            {data.checkins.map((c) => (
              <div key={c.id} data-testid={`checkin-row-${c.id}`} className="text-sm border-b border-white/5 pb-2">
                <p><b>{c.user_name}</b> · <span className="text-white/60">{c.event_title}</span> · <span className={ANSWER_CLS[c.answer]}>{c.answer_label}</span>
                  <span className="text-[11px] text-white/40 ml-2">{(c.updated_at || "").slice(0, 10)}</span></p>
                {c.comment && <p className="text-xs text-white/60 mt-0.5 italic">“{c.comment}”</p>}
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};
